import { axios } from "../lib/axios";

export const getAllAppointments = async function (
  serviceProviderId,
  dateFrom,
  dateTo
) {
  try {
    console.log(serviceProviderId);
    console.log(dateFrom);

    const response = await axios.get("appointment/getappointments", {
      params: {
        serviceProviderId: serviceProviderId,
        dateFrom: dateFrom,
        dateTo: dateTo,
      },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getPatientName = async function (userId) {
  try {
    const response = await axios.get("patient/getpatientname", {
      params: {
        userId,
      },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};
